import { useEffect, useState } from "react"

export function useDelayGate(delayMs: number, key: string) {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null
    setReady(false)
    timer = setTimeout(() => setReady(true), delayMs)
    return () => {
      if (timer) clearTimeout(timer)
    }
  }, [delayMs, key])

  return { ready }
}
